<!--功能：未评价处理模态窗-->
<template>
  <div>
    <vxe-modal v-model="formVisible" :title="title" width="80%" height="80%" @hide="closed()">
      <div class="tabBox">
        <vxe-table
          ref="xTable"
          size="mini"
          :column-config="{ minWidth: '80px' }"
          :show-overflow="false"
          :scroll-y="{ enabled: false }"
          border
          :height="scrollerHeight"
          resizable
          :data="tableData"
          :mouse-config="{ area: true, extension: true }"
          highlight-hover-row
          highlight-current-row
          :keyboard-config="{
            isArrow: true,
            isEnter: true,
            isTab: true,
            enterToTab: true,
            isClip: true
          }"
          @cell-menu="cellContextMenuEvent"
          :menu-config="{
            body: { options: bodyMenus },
            visibleMethod: visibleMethod
          }"
          @menu-click="contextMenuClickEvent"
        >
          <vxe-column type="seq" width="40px" fixed="left"></vxe-column>
          <vxe-column
            fixed="left"
            width="110px"
            field="groupName"
            title="模块"
            :filters="[
              {
                data: {
                  vals: [],
                  sVal: '',
                  fMenu: '',
                  f1Type: '',
                  f1Val: '',
                  fMode: 'and',
                  f2Type: '',
                  f2Val: ''
                }
              }
            ]"
            :filterRender="{ name: 'FilterExtend' }"
          ></vxe-column>
          <vxe-column
            fixed="left"
            width="110px"
            field="vuePath"
            title="菜单"
            :filters="[
              {
                data: {
                  vals: [],
                  sVal: '',
                  fMenu: '',
                  f1Type: '',
                  f1Val: '',
                  fMode: 'and',
                  f2Type: '',
                  f2Val: ''
                }
              }
            ]"
            :filterRender="{ name: 'FilterExtend' }"
          ></vxe-column>
          <vxe-column width="160px" fixed="left" field="registrationInformationGroup" title="登记信息">
            <template #default="{ row }">
              <div class="label-ellipsis">{{ row.recorder }}</div>
              <div class="label-ellipsis">
                {{ ykDateFormat('yyyy-MM-dd', row.recordDate) }}
              </div>
            </template>
          </vxe-column>
          <vxe-column width="50%" field="requirementDesc" title="需求描述"></vxe-column>
          <vxe-column field="processingInformationGroup" title="处理信息" min-width="100px">
            <template #default="{ row }">
              <div class="label-ellipsis">{{ row.handler }} {{ row.handleResult }}</div>
              <!-- <div class="label-ellipsis">{{ row.handler }}</div> -->
              <div class="label-ellipsis" v-if="row.pid === 0 && row.handleNote">说明: {{ row.handleNote }}</div>
              <div class="label-ellipsis">
                {{ ykDateFormat('yyyy-MM-dd', row.handleTime) }}
              </div>
            </template>
          </vxe-column>
          <vxe-column field="assessmentInformationGroup" title="评价信息" min-width="100px">
            <template #default="{ row }">
              <div class="label-ellipsis">{{ row.assessResult }}</div>
              <div class="label-ellipsis" v-if="row.pid === 0 && row.assessNote">说明: {{ row.assessNote }}</div>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </vxe-modal>
    <!-- 评价模态窗 -->
    <AssessModal ref="AssessModal" @sureHandler="AssessSureBack" />
  </div>
</template>
<script>
import AssessModal from '../RequirementsGather/AssessModal.vue'
export default {
  props: {
    tableData: {
      type: Array
    }
  },
  components: {
    AssessModal
  },
  data() {
    return {
      // 是否显示
      formVisible: false,
      // 标题
      title: '未评价处理',
      bodyMenus: [
        [
          {
            code: 'handleAssess',
            name: '评价'
          }
        ]
      ],
      // 右键缓存
      areas: {},
      colProperty: '',
      // 缓存idlist
      cellIdList: [],
      // 是否需要关闭窗口刷新
      needRefresh: false
    }
  },
  created() {},
  methods: {
    // 关闭窗口时
    closed() {
      if (this.needRefresh) {
        this.$parent['refresh']()
      }
    },
    // 按下右键缓存选中列
    cellContextMenuEvent({ column }) {
      this.areas = this.$refs.xTable.getCellAreas()
      this.colProperty = column.property
      this.cellIdList = []
    },
    // 右键控制菜单方法
    visibleMethod({ options, column }) {
      // 显示之前处理按钮的操作权限
      options.forEach(list => {
        list.forEach(item => {
          if (column) {
            switch (item.code) {
              case 'handleAssess':
                item.visible = true
                break
            }
          } else {
            item.visible = false
          }
        })
      })
      return true
    },
    // 右键确认
    contextMenuClickEvent({ menu }) {
      // 取出可执行的明细id
      for (let area of this.areas) {
        for (let row of area.rows) {
          if (
            menu.code === 'handleAssess' &&
            row.handleResult === '接收' &&
            row.assessResult === '' &&
            !this.cellIdList.includes(row.id) &&
            row.userCompany === this.$store.state.userInfo.company
          ) {
            this.cellIdList.push(row.id)
          }
        }
      }
      if (this.cellIdList.length === 0) {
        this.$message.error('您没有选中需要您处理的明细!')
        return
      }
      if (menu.code === 'handleAssess') {
        this.$refs.AssessModal.formVisible = true
      }
    },
    // 评价回调
    async AssessSureBack({ assessResult, assessNote }) {
      const that = this
      this.$confirm('评价之后不能撤回, 是否继续评价?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      }).then(async () => {
        const { data: res } = await that.$http.put('/Bugs/YKDataProcessing/assess', {
          idList: that.cellIdList,
          assessResult: assessResult,
          assessNote: assessNote
        })
        if (!res.isSuccess) {
          that.$message.error(res.errorMessage)
          return false
        }
        that.needRefresh = true
        that.$message.success(res.data)
        that.$parent['beforeAddOrUpdate']('add')
      })
    }
  },
  computed: {
    // 滚动区高度
    scrollerHeight: function () {
      return this.$store.state.clientHeight * 0.8 - 80 + 'px'
    }
  }
}
</script>
<style lang="less" scoped></style>
